import { css } from '@emotion/react';

import { postShape } from 'components/InfoCenter/InfoCenter.config';

import PostTitle from '../PostTitle/PostTitle';
import Container from '../Container/Container';
import PostMedia from '../PostMedia/PostMedia';
import PostMetadata from '../PostMetadata/PostMetadata';
import PostRichText from '../PostRichText/PostRichText';

const postCss = css`
  flex-grow: 1;
`;

function PostLayout({
  image,
  isVideo,
  length,
  lengthDescribed,
  reviewer,
  richText,
  title,
  videoId,
}) {
  return (
    <article css={postCss}>
      <Container>
        {/* Media */}
        <PostMedia image={image} isVideo={isVideo} videoId={videoId} />

        {/* Title */}
        <PostTitle>{title}</PostTitle>

        {/* Metadata */}
        <PostMetadata
          isVideo={isVideo}
          length={length}
          lengthDescribed={lengthDescribed}
          reviewer={reviewer}
        />

        {/* Rich text */}
        {richText && <PostRichText text={richText} />}
      </Container>
    </article>
  );
}

PostLayout.propTypes = {
  ...postShape,
};

export default PostLayout;
